import React from "react";

interface FeatureItemProps {
    children: React.ReactNode;
}

const FeatureItem: React.FC<FeatureItemProps> = ({ children }) => (
    <div className="flex items-center gap-2.5 py-3">
        <div className="shrink-0">
            <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
                <g clipPath="url(#clip0_775_16912)">
                    <path fillRule="evenodd" clipRule="evenodd" d="M1 8C1 8.47339 1.39175 8.85714 1.875 8.85714L12.0126 8.85714L8.25628 12.5368C7.91457 12.8715 7.91457 13.4142 8.25628 13.7489C8.59799 14.0837 9.15201 14.0837 9.49372 13.7489L14.7437 8.60609C15.0854 8.27136 15.0854 7.72864 14.7437 7.39391L9.49372 2.25105C9.15201 1.91632 8.59799 1.91632 8.25628 2.25105C7.91457 2.58579 7.91457 3.1285 8.25628 3.46323L12.0126 7.14286L1.875 7.14286C1.39175 7.14286 1 7.52661 1 8Z" fill="#1B515E" />
                </g>
                <defs>
                    <clipPath id="clip0_775_16912">
                        <rect width="16" height="16" fill="white" />
                    </clipPath>
                </defs>
            </svg>
        </div>
        <p className="text-[#1D1D1D] font-normal text-[14px] leading-5 tracking-[0.2px]">{children}</p>
    </div>
);

export default FeatureItem;
